import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface FormTransitionProps {
  children: React.ReactNode;
  key: string;
}

const formVariants = {
  initial: {
    opacity: 0,
    x: 10,
  },
  in: {
    opacity: 1,
    x: 0,
  },
  out: {
    opacity: 0,
    x: -10,
  },
};

const formTransition = {
  type: 'tween' as const,
  ease: 'easeInOut' as const,
  duration: 0.25,
};

export const FormTransition: React.FC<FormTransitionProps> = ({ children, key }) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={key}
        initial="initial"
        animate="in"
        exit="out"
        variants={formVariants}
        transition={formTransition}
        className="w-full"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default FormTransition; 